var NewCampaignCtrl = function (Notification, gettextCatalog) {
  this.parentType = 'automated';
  this.type = 'birthday';
};

module.exports = NewCampaignCtrl;
